module.exports = __webpack_public_path__ + "img/Najarian-2.71f48f23.png";